/**
 *
 * This mixin is shared by the main cart and the mini-cart
 */

import { mapGetters, mapState } from 'vuex'
import { registerStores } from '@/helpers/stores'
import { MESSAGE_TYPES } from '@/stores/flash'
import checkoutStore from '@/stores/checkout'

export default {
  data() {
    return {
      deliveryNoticeHeight: 0,
      isSubmitting: false,
      itemHeight: 0,
      itemIsGettingAdded: false,
      itemsLength: 0,
      recommendedProduct: {},
      recommendedVariant: {},
      cartDataFetched: false,
      itemOutOfStockMessageId: -1,
    }
  },

  computed: {
    ...mapState('order', ['cartItemIsLoading']),
    ...mapGetters({
      getAmountWithCurrency: 'store/getAmountWithCurrency',
      adjustmentIsLoading: 'order/adjustmentIsLoading',
      quickAdding: 'order/quickAdding',
      orderIsInitialized: 'order/dataIsInitialized',
      items: 'order/items',
      itemTotal: 'order/itemTotal',
      shippingTotal: 'order/shippingTotal',
      taxLines: 'order/taxLines',
      canShowTaxLines: 'order/canShowTaxLines',
      total: 'order/total',
      usedStoreCredit: 'order/usedStoreCredit',
      remainingStoreCredit: 'order/remainingStoreCredit',
      isStoreCreditUsed: 'order/isStoreCreditUsed',
      isExcludedFromStoreCredit: 'order/isExcludedFromStoreCredit',
      hasAvailableStoreCredits: 'account/hasAvailableStoreCredits',
      mergedItemIndex: 'order/mergedItemIndex',
      itemsCount: 'order/itemsCount',
      homepageUrl: 'page/homepageUrl',
      itemOutOfStock: 'order/itemOutOfStock',
      isPreorder: 'order/isPreorder',
      isCyclon: 'order/isCyclon',
    }),

    recommendationPrice() {
      const amount = Number(this.recommendedProduct.price)
      return this.getAmountWithCurrency(amount)
    },

    totalWithCurency() {
      return this.getAmountWithCurrency(this.total)
    },
  },

  watch: {
    orderIsInitialized() {
      requestAnimationFrame(() => {
        const height = this.$refs.cartItems?.scrollHeight / Number(this.itemsLength)
        this.itemHeight = isNaN(height) ? 157 : height
        if (this.$refs.cartContent) {
          this.addTransitionEndListener()
          this.$refs.cartContent.style.minHeight = `${this.$refs.cartItems.scrollHeight}px`
        }
        this.cartDataFetched = true
      })
    },

    items() {
      // Only animate first item when adding, not removing items
      if (this.itemsLength < this.items.length) {
        this.itemIsGettingAdded = true
        this.$nextTick(() => (this.itemIsGettingAdded = false))
      }
      this.itemsLength = this.items.length
    },

    itemOutOfStock() {
      if (this.itemOutOfStock) {
        const { id } = this.$store.dispatch('flash/addMessage', {
          text: this.$t('minicart.out_of_stock_error'),
          type: MESSAGE_TYPES.error,
          context: this.flashContext,
        })
        this.itemOutOfStockMessageId = id
      } else {
        this.$store.dispatch('flash/removeMessage', this.itemOutOfStockMessageId)
      }
    },
  },

  beforeCreate() {
    registerStores({ checkout: checkoutStore })
  },

  methods: {
    onCartContentChange(index) {
      this.items.splice(index, 1)
    },

    redirectToCheckout() {
      this.isSubmitting = true

      this.$store.dispatch('order/redirectToCheckout', {
        onError: message => {
          this.isSubmitting = false
          this.$store.dispatch('flash/addMessage', {
            text: message,
            type: 'error',
            context: this.flashContext,
          })
        },
      })
    },
  },
}
